/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DoneTotals
 */
export interface DoneTotals {
    /**
     * 
     * @type {number}
     * @memberof DoneTotals
     */
    projectId: number;
    /**
     * 
     * @type {number}
     * @memberof DoneTotals
     */
    totalDoneAmount: number;
}

/**
 * Check if a given object implements the DoneTotals interface.
 */
export function instanceOfDoneTotals(value: object): value is DoneTotals {
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('totalDoneAmount' in value) || value['totalDoneAmount'] === undefined) return false;
    return true;
}

export function DoneTotalsFromJSON(json: any): DoneTotals {
    return DoneTotalsFromJSONTyped(json, false);
}

export function DoneTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoneTotals {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'totalDoneAmount': json['totalDoneAmount'],
    };
}

  export function DoneTotalsToJSON(json: any): DoneTotals {
      return DoneTotalsToJSONTyped(json, false);
  }

  export function DoneTotalsToJSONTyped(value?: DoneTotals | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectId': value['projectId'],
        'totalDoneAmount': value['totalDoneAmount'],
    };
}

